import { Folder } from '@/modules/file/components/folder-nav/types'
import { BuildFoldersParams } from '../interfaces'
import { FileInterface } from '../../lists/requests/_helpers/interfaces'

const buildFolders = (
  items: FileInterface[],
  { currentFolder, folders }: BuildFoldersParams,
) => {
  if (currentFolder.name && typeof currentFolder.path === 'string') {
    const path = [...currentFolder.path.split('/'), currentFolder.name]
    let folder: Folder = folders
    path.forEach((name) => {
      folder = folder.children.find((folder) => folder.name === name) ?? folder
    })
    currentFolder = folder
  } else {
    currentFolder = (currentFolder.isRoot && folders) || { children: [], files: [], isRoot: true } as Folder
  }

  currentFolder.files = currentFolder?.id ? items.filter(({ folderId }) => folderId === currentFolder.id) : items

  return { currentFolder, folders }
}

export default buildFolders
